// extracted by mini-css-extract-plugin
export default {"heroWrapper":"registry-discount__heroWrapper__tf4ew","heroImage":"registry-discount__heroImage__YnucS","termsList":"registry-discount__termsList___DqID"};